// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file suppliers/list_suppliers.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Supplier } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ListSuppliersRequest
 */
export class ListSuppliersRequest extends Message<ListSuppliersRequest> {
  /**
   * Optional search query to filter suppliers
   *
   * @generated from field: string search_query = 1;
   */
  searchQuery = "";

  /**
   * Page number for pagination
   *
   * @generated from field: int32 page = 2;
   */
  page = 0;

  /**
   * Number of suppliers per page
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<ListSuppliersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListSuppliersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "search_query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSuppliersRequest {
    return new ListSuppliersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSuppliersRequest {
    return new ListSuppliersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSuppliersRequest {
    return new ListSuppliersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSuppliersRequest | PlainMessage<ListSuppliersRequest> | undefined, b: ListSuppliersRequest | PlainMessage<ListSuppliersRequest> | undefined): boolean {
    return proto3.util.equals(ListSuppliersRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ListSuppliersResponse
 */
export class ListSuppliersResponse extends Message<ListSuppliersResponse> {
  /**
   * List of suppliers
   *
   * @generated from field: repeated com.neulink.pharmacy.Supplier suppliers = 1;
   */
  suppliers: Supplier[] = [];

  /**
   * Total number of suppliers matching the search query
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ListSuppliersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListSuppliersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "suppliers", kind: "message", T: Supplier, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSuppliersResponse {
    return new ListSuppliersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSuppliersResponse {
    return new ListSuppliersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSuppliersResponse {
    return new ListSuppliersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSuppliersResponse | PlainMessage<ListSuppliersResponse> | undefined, b: ListSuppliersResponse | PlainMessage<ListSuppliersResponse> | undefined): boolean {
    return proto3.util.equals(ListSuppliersResponse, a, b);
  }
}

